import React, { useContext, useEffect, useState } from "react";
import { JSDCContext, JSDCProvider } from "jsdc-dui/dist/JSDC/Context";
import JSDC from "jsdc-dui/dist/JSDC";
import { latLng, latLngBounds } from "leaflet";
import {
  IDuiContextProviderProps,
  DuiContextProvider,
} from "jsdc-dui/dist/components/Context";
import DguideWalksApp from "jsdc-dui/dist/components/DguideWalksApp";
import { DguidewalksProvider } from "jsdc-dui/dist/JSDC/Dguidewalks/Context";
import "jsdc-dui/dist/style/index.css";
import "./index.scss";
import ConfigProvider from "jsdc-dui/dist/JSDC/Dguidewalks/ConfigProvider";
import headerImg from "./assets/key-art_Desktop.png";
import headerImgMb from "./assets/key-art_mobile.jpg";
import aboutImg from "./assets/about.png";

//TODO: EVENT_ID
const EVENT_ID = "s0009";

//TODO: aboutWalkContent
const aboutWalkContent = `臺南市擁有豐富多元的民俗文化資產，涵蓋規模龐大、跨區域動員的王醮香科儀式，歷史悠久的謁祖遶境活動，以及充滿地方特色的在地民俗，展現出信仰與生活交織的文化樣貌。
 
 本計畫聚焦於六項具代表性的臺南民俗文化資產，包括：西港刈香、將軍苓仔寮保濟宮冬至送火王、安平鎮城隍廟公普、東山碧軒寺迎佛祖暨遶境、府城縣城隍夜巡，以及東山吉貝耍夜祭。這些活動兼具地域性、信仰性與藝術性，是臺南民俗文化多樣性與活力的具體體現。
 
 本計畫將透過實境遊戲與文化推廣活動，帶領大眾走進儀式現場，深入理解背後的故事與價值。以活潑有趣、富含文化內涵的方式，轉化為易於參與的體驗，拉近民眾與傳統文化的距離，讓更多人感受臺南民俗的深厚底蘊與獨特魅力。`;

//TODO: credit
const credit = `
<div>
    團隊介紹：臺南市文化資產管理處「臺南民俗文化資產推廣體驗計畫─『實境遊戲及智慧導覽服務建置』」<br>
    <br>
    本圖臺是由臺南市文化資產管理處及智紳數位文化有限公司共同協力建置：
    <br>1. 圖臺內容：臺南市文化資產管理處
    <br>2. 圖臺系統開發：智紳數位文化事業有限公司
    <br>
    <br>本圖台內其內容著作財產權由上述單位保有，若有其他利用或授權需求，請洽臺南市文化資產管理處，官方網址：<a style="color: #1765b2;"href="https://tmach-culture.tainan.gov.tw/" target="_blank">https://tmach-culture.tainan.gov.tw/</a>
    <br>
    <br><img style="width: 100%;" src="./臺南市文化資產管理處LOGO.png" alt="臺南市文化資產管理處" />
  </div>
`;

const duiConfigProps: IDuiContextProviderProps = {
  sidebarTitle: "",
  sidebarSubtitle: "",
  aboutWalkImgSrc: aboutImg,
  aboutWalkContent,
  credit,
  creditHref: "https://www.facebook.com/JRSHENDigitalCulture/",
  headerMBImgSrc: headerImgMb,
  headerDImgSrc: headerImg,
  menuSwitchItems: [{ id: "數位集章", name: "數位集章" }],
  weatherConfig: {
    token: "CWB-232A270E-12F1-4381-B9F2-DF2D2670A077",
    locations: [
      { county: "臺南市", town: "安平區" },
      { county: "臺南市", town: "西港區" },
      { county: "臺南市", town: "將軍區" },
      { county: "臺南市", town: "東山區" },
      { county: "臺南市", town: "北區" },
    ], //TODO: weather 氣象預測地點
  },
  themeConfig: {
    "--dui-primary": "#e06f6d", //TODO: theme
    "--dui-accent": "#1765b2", //TODO: 數位集章按鈕顏色, more按鈕
    "--dui-secondary": "#e06f6d", //TODO: theme
    "--dui-bg-secondary": "#ffc361", // Dialog background
    "--dui-bg-accent": "#3f5085", //TODO: background
  },
  settingConfig: {
    disabled: true, // 左側選單不出現「工具設定」
    // languageSwitcherDisabled: true, // 或：保留「工具設定」，只藏語言切換器
  },
};
// #e4e7cb
// 景點的 icon、點擊開集章卡片、cluster、集章 key、`?id=` 深連結、
// 列表的定位與導航、底圖、線都由 jsdc-dui 依 Strapi 的資料建立，這裡不需要再處理圖層。
function App() {
  const { Jsdc } = useContext(JSDCContext);

  useEffect(() => {
    (window as any).JSDC = Jsdc;
  }, [Jsdc]);

  return (
    <div className="root">
      <DguideWalksApp
      language="zh-TW"
      //! 左側數位集章選項
      // mainMenuChildren={
      //   <MenuItemWithDialog
      //     Icon={Checkin}
      //     title="路線顏色"
      //     active={dui.activeMenuId === '數位集章'}
      //     {...dui.menuSwitcherAction('數位集章')}
      //   >
      //     {/* {dui.activeMenuId === '數位集章' && (
      //       <iframe
      //         style={{ height: '100%', border: 0, borderRadius: '5px' }}
      //         src={`https://map.jsdc.com.tw/tools/checkin/${EVENT_ID}/showlist.php?a=${EVENT_ID}`}
      //       ></iframe>
      //     )} */}
      //     //? 設定線條顏色
      //     {paths.map(path => (
      //       <div
      //         key={path.name}
      //         style={{
      //           display: 'flex',
      //           alignItems: 'center',
      //           margin: '20px',
      //         }}
      //       >
      //         <div
      //           style={{
      //             width: '50px',
      //             height: '5px',
      //             backgroundColor: path.color,
      //             alignItems: 'center',
      //             marginRight: '10px',
      //           }}
      //         ></div>
      //         <span
      //           style={{
      //             fontSize: '20px',
      //             color: '#000',
      //             // fontWeight: "bold",
      //           }}
      //         >{` ：${path.name}`}</span>
      //       </div>
      //     ))}
      //   </MenuItemWithDialog>
      // }
      />
    </div>
  );
}

const config = new ConfigProvider({ eventId: EVENT_ID });

const AppWrapper: React.FC = () => {
  const [Jsdc] = useState(
    new JSDC(EVENT_ID, {
      bound: latLngBounds(
        //TODO: map view bound
        latLng(23.353826742782783, 119.97067699205701),
        latLng(22.935303736786054, 120.57213460790346)
      ),
      maxZoom: 17,
    })
  );

  return (
    <JSDCProvider Jsdc={Jsdc}>
      <DguidewalksProvider
        Jsdc={Jsdc}
        config={config}
      >
        <DuiContextProvider {...duiConfigProps}>
          <App />
        </DuiContextProvider>
      </DguidewalksProvider>
    </JSDCProvider>
  );
};

export default AppWrapper;
